import {
  useRemoteStorage,
  WHATS_NEW_PERIOD,
} from '@terminal/hooks/use-remote-storage';
import { useInsightFeedFilters } from '@terminal/stores/use-insight-feed-filters/useInsightFeedFilters';

import type { InsightsPeriod } from '../types';
import { DEFAULT_WHATS_NEW_PERIOD } from '../types';

export type WhatsNewSettings = {
  selectedWatchlists: { id: string }[] | undefined;
  period: InsightsPeriod;
  includeCompetitors: boolean | undefined;
};

export const useWhatsNewSettings = (): WhatsNewSettings => {
  const items = useRemoteStorage(state => state.items);

  const { selectedWatchlistIds, isSecondRelationshipEnabled } =
    useInsightFeedFilters(state => ({
      selectedWatchlistIds: state.selectedWatchlistIds,
      isSecondRelationshipEnabled: state.isSecondRelationshipEnabled,
    }));

  const period = items?.[WHATS_NEW_PERIOD] ?? DEFAULT_WHATS_NEW_PERIOD;

  return {
    selectedWatchlists:
      selectedWatchlistIds.size > 0
        ? Array.from(selectedWatchlistIds).map(id => ({ id }))
        : undefined,
    period,
    includeCompetitors: isSecondRelationshipEnabled,
  };
};
